/* eslint-disable max-len */
export const VALIDATION_MESSAGE = {
  REQUIRED: 'Field is required',
  MUST_SELECT_AT_LEAST: (size: number): string =>
    `Must select at least ${size} value`,
  MUST_SELECT_ONE: 'Must select a value',
  MUST_BE_NUMBER: 'Must be a number',
  MUST_BE_NUMBER_FORMAT:
    'Must be in this format 00000.00 or -00000.00 without commas or $ symbol',
  AT_MOST_CHARS: (size: number): string => `Must be at most ${size} characters`,
  EXACT_NUMBER_LENGTH: (size: number): string =>
    `Must be exactly ${size} digits`,
  EXACT_LENGTH: (size: number): string => `Must be exactly ${size} characters`,
  NO_SPECIAL_CHARACTERS: 'No special characters allowed',
  ALPHANUMERIC: 'Letters and digits only',
  BEFORE_OR_EQUAL_TO_DATE: (displayName: string): string =>
    `Date must be after (or equal to) ${displayName}`,
  AFTER_OR_EQUAL_TO_DATE: (displayName: string): string =>
    `Date must be before (or equal to) ${displayName}`,
  BEFORE_DATE: (displayName: string): string =>
    `Date must be after ${displayName}`,
  MUST_BE_IN_SSN_FORMAT: 'Must be in the format XXX-XX-XXXX',
  EQUAL_TO_OR_EARLIER: 'Must be equal or earlier than today',
  MUST_NOT_BE_EQUAL_TO: (enteredValue: string): string =>
    `Must not be equal to ${enteredValue}`,
  MUST_BE_IN_PHONE_NUMBER_FORMAT: 'Must be in the format XXX-XXX-XXXX',
  ALPHANUMERIC_WITH_DASH: 'Letters, digits and dash only',
  LETTERS_AND_NUMBERS_ONLY: 'letters and numbers only',
  MUST_BE_JUST_CHARACTERS: 'Must be characters only',
  MUST_BE_LETTERS_NUMBERS_PERIOD_HYPHEN_OR_SLASH:
    'Must be letters, numbers, period, hyphen -, or forward slash /.',
  MUST_BE_JUST_CHARACTERS_WITH_DOT_COMMA: 'Must be characters or dot only',
  MUST_HAVE_ALL_MSIS_PRIMARY_FIELDS:
    'Must enter all fields First Name, Last Name, Email, and MSIS primary phonenumber',
  MUST_BE_IN_VALID_EMAIL_FORMAT: 'Please enter valid email address',
  MUST_BE_IN_ZIP_CODE_FORMAT: 'Numbers and dashes only, min of 5 characters',
  MUST_BE_IN_BETWEEN_RANGE: (size: number, size2: number): string =>
    `Must be between ${size} and ${size2} characters`,
  MUST_BE_EXACT_NUMBER_LENGTH: (size: number): string =>
    `Must be ${size} digits`,
  MUST_BE_VALID_DATE: 'Date must be mm/dd/yyyy',
  DATE_INVALID_CHARACTERS: 'Must be numbers, hyphen -, or forward slash /',
  IS_EMPTY: '',
  CANNOT_BE_NEGATIVE: 'Value cannot be negative',
  CANNOT_BE_SMALLER_THAN: (referenceFieldDisplayName: string): string =>
    `Value cannot be less than ${referenceFieldDisplayName}`,
  CANNOT_BE_GREATER_THAN: (referenceFieldDisplayName: string): string =>
    `Value cannot be greater than ${referenceFieldDisplayName}`,
  MUST_BE_GREATER_THAN_OR_EQUAL_TO_ZERO:
    'Value must be greater than or equal to 0.',
  IN_SCHOOL_YEAR_AND_NOT_AFTER_TODAY: (fieldName: string): string =>
    `${fieldName} must be in the current school year and no greater than today. Must be in mm/dd/yyyy format.`,
  LITERACY_SCREENING_NOTIFICATION_DATE:
    'Date cannot be a future date and must be in the current school year and no greater than today. Must be in mm/dd/yyyy format.',
  LITERACY_SCREENING_DIAGNOSTIC_MEASURES_REQUIRED:
    'At least one Diagnostic Measures value must be selected.',
  LITERACY_SCREENING_EXPLANATION_REQUIRED: 'Explanation is required',
  LITERACY_SCREENING_INVOICE_LEVEL_REQUIRED: 'Invoice Level is required',
  LITERACY_SCREENING_SCHOOL_REQUIRED: 'School is required',
  LITERACY_SCREENING_SCREENER_INVOICE_REQUIRED: 'Screener Invoice is required',
  LITERACY_SCREENING_COMMENTS_REQUIRED: 'Comments are required',
  MUST_BE_LESS_THAN_OR_EQUAL_TO_FIELD: (
    fieldName: string,
    compareFieldName: string
  ): string =>
    `${fieldName} must be less than or equal to the ${compareFieldName}.`,
  MUST_BE_GREATER_THAN_OR_EQUAL_TO_FIELD: (
    fieldName: string,
    compareFieldName: string
  ): string =>
    `${fieldName} must be greater than or equal to the ${compareFieldName}.`,
};
